import { useProfileQuery } from '~/queries/useProfileQuery';
import { getPublisherIdForMerchant } from '~~/models/UserProfile';

export type UseMerchantPublisherIdOptions = {
	merchantId: MaybeRef<string | undefined>;
};

export const useMerchantPublisherId = (options: UseMerchantPublisherIdOptions) => {
	const { data: profile, isLoading } = useProfileQuery();

	const merchantId = computed(() => unref(options.merchantId));

	const publisherId = computed<number | null>(() => {
		if (!merchantId.value || !profile.value) {
			return null;
		}
		return getPublisherIdForMerchant(profile.value, merchantId.value) ?? null;
	});

	return {
		publisherId,
		isLoading,
	};
};
